const ID_TOKEN_KEY = 'access_token';
const CURRENT_USER = 'current_user';

export function getToken() {
  try {
    const raw = window.sessionStorage.getItem(ID_TOKEN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function getUser() {
  try {
    const raw = window.sessionStorage.getItem(CURRENT_USER);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export default { getToken, getUser };
